import { Controller, Control, UseFormSetValue, useWatch } from 'react-hook-form';
import { FormControl, InputLabel, MenuItem, Select, Stack } from '@mui/material';
import { SmartIntakeDateRangeFilter } from './SmartIntakeDateRangeFilter';
import { SmartIntakeFiltersForm, QuickDatePreset } from './SmartIntakeTypes';

const OUTCOME_OPTIONS = [
  { value: '', label: 'All' },
  { value: 'confirmed', label: 'Confirmed' },
  { value: 'rejected', label: 'Rejected' },
  { value: 'failed', label: 'Failed' },
];

interface Props {
  control: Control<SmartIntakeFiltersForm>;
  setValue: UseFormSetValue<SmartIntakeFiltersForm>;
  activePreset: QuickDatePreset | null;
  onPresetChange: (preset: QuickDatePreset) => void;
  reviewedByOptions: string[];
  uploadedByOptions: string[];
}

export const SmartIntakeHistoryFilters = ({
  control,
  setValue,
  activePreset,
  onPresetChange,
  reviewedByOptions,
  uploadedByOptions,
}: Props) => {
  const from = useWatch({ control, name: 'from' });
  const to = useWatch({ control, name: 'to' });

  return (
    <Stack direction="row" spacing={2} alignItems="flex-start" flexWrap="wrap">
      <SmartIntakeDateRangeFilter
        control={control}
        setValue={setValue}
        activePreset={activePreset}
        onPresetChange={onPresetChange}
        from={from}
        to={to}
      />

      <Controller
        name="outcome"
        control={control}
        render={({ field }) => (
          <FormControl size="small" sx={{ width: 280 }}>
            <InputLabel>Outcome</InputLabel>
            <Select {...field} label="Outcome">
              {OUTCOME_OPTIONS.map(opt => (
                <MenuItem key={opt.value} value={opt.value}>
                  {opt.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
      />

      <Controller
        name="reviewedBy"
        control={control}
        render={({ field }) => (
          <FormControl size="small" sx={{ width: 280 }}>
            <InputLabel>Reviewed by</InputLabel>
            <Select {...field} label="Reviewed by">
              <MenuItem value="">All</MenuItem>
              {reviewedByOptions.map(name => (
                <MenuItem key={name} value={name}>
                  {name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
      />

      <Controller
        name="uploadedBy"
        control={control}
        render={({ field }) => (
          <FormControl size="small" sx={{ width: 280 }}>
            <InputLabel>Uploaded by</InputLabel>
            <Select {...field} label="Uploaded by">
              <MenuItem value="">All</MenuItem>
              {uploadedByOptions.map(name => (
                <MenuItem key={name} value={name}>
                  {name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
      />
    </Stack>
  );
};
